import { render } from "./InputBestScoreName.vue?vue&type=template&id=2137f2e2&scoped=true"
import script from "./InputBestScoreName.vue?vue&type=script&lang=js"
export * from "./InputBestScoreName.vue?vue&type=script&lang=js"

import "./InputBestScoreName.vue?vue&type=style&index=0&id=2137f2e2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2137f2e2"

export default script